module.exports = __webpack_public_path__ + "statics/img/image1.2aa68afd.png";